<template>
   <slide-transition>
      <div v-if="isSuccess" class="text-center">
         <check-mark color="success" size="x-large"/>
         <atom-text color="success">
            {{text}}
         </atom-text>
      </div>
   </slide-transition>
</template>

<script>
import AtomText from '../../../atoms/Login/Text';
import CheckMark from '../../../atoms/Login/CheckMark';
import SlideTransition from '../../../atoms/Login/SlideTransition';

export default {
   components: {
      AtomText,
      CheckMark,
      SlideTransition,
   },
   props: {
      text: {
         type: String,
         required: true,
      },
      isSuccess: {
         type: Boolean,
         default: true,
      }
   }
}
</script>

<style scoped>
.text-center {
   text-align: center;
}
</style>